import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import {
  getBatchesList,
  getCardsData,
  getCourseAvailable,
  getSmoSmeLeads,
} from "../../redux/features/batchSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import Searchbar from "../../components/Search/Searchbar";
import { CRM_Batch_View_Table_Head } from "../../components/datagrid/myworkspace/cro/CrmBatchTableHead";
import SubjectAndTutors from "./SubjectAndTutors";
import CardsData from "./CardsData";
import AssignSme from "./SmeAssign";

const SMEbatchLeads = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, smoSmeLeads, allcourses, cardData } = useSelector(
    (state) => state.batch
  );
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [assignopen, setAssignOpen] = useState(false);
  const [subjectopen, setSubjectOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [course, setSelectedCourse] = useState("");
  const [status, setSelectedStatus] = useState("");
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const data = {
    page: pageNum,
    limit: gridSize,
    search: value,
    course_available_id: course || "",
    course_batch_status: status || "",
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getSmoSmeLeads(data));
    }
  }, [pageNum, gridSize, value, course, status]);

  useEffect(() => {
    dispatch(getCourseAvailable());
    dispatch(getCardsData());
  }, []);

  const columns = useMemo(
    () => [
      ...CRM_Batch_View_Table_Head,
      {
        field: "subject",
        minWidth: 200,
        headerName: "Subjects And Tutors",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={() => {
                setSelectedRow(params.row);
                setSubjectOpen(true);
              }}
            >
              <Icon icon={"carbon:task-view"} width={18} height={18} />
            </Button>
          );
        },
      },
      {
        field: "batchCalendar",
        headerName: "Batch Calendar",
        width: 200,
        renderCell: (params) => (
          <Button
            startIcon={<Icon icon="bx:calendar" />}
            variant="outlined"
            size="small"
            color="secondary"
            onClick={() => {
              navigate(
                `/my-workspace/batch-academic-calendar?BatchID=${params.row.course_batch_id}`,
                { state: { batchDetails: params.row } }
              );
            }}
          >
            View Batch Calendar
          </Button>
        ),
      },
      {
        field: "smetopic",
        headerName: "Batch Topics",
        width: 150,
        renderCell: (params) => (
          <Button
            startIcon={
              <Icon icon="material-symbols-light:assignment-add-rounded" />
            }
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => {
              navigate(
                `/my-workspace/sme-topicschedules?BatchID=${params.row.course_batch_id}`,
                { state: { batchDetails: params.row } }
              );
            }}
          >
            Add Topics
          </Button>
        ),
      },
    ],
    [CRM_Batch_View_Table_Head]
  );

  const handlecourses = (e, option) => {
    setSelectedCourse(option?.course_available_id || "");
  };
  const handlestatus = (e, option) => {
    setSelectedStatus(option?.id || "");
  };

  const BatchStatuses = [
    { id: 1, name: "Active" },
    { id: 2, name: "Temporary Inactive" },
    { id: 3, name: "Upcoming" },
    { id: 4, name: "Completed" },
  ];

  return (
    <GlobalWrapper
      title={"SME Batch Assignments"}
      // actions={<Addbatch dispatchParams={data} />}
      // actions={<AssignBatch />}
    >
      <CardsData />
      <Box
        sx={{
          width: "100%",
          padding: 0,
          mb: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Searchbar
              value={value}
              setValue={setValue}
              label={"Search Batch/Cro"}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              name="Courses"
              fullWidth
              options={allcourses}
              getOptionLabel={(option) => option.course_name || ""}
              onChange={handlecourses}
              value={
                allcourses.find(
                  (courseOption) => courseOption.course_available_id === course
                ) || ""
              }
              renderInput={(params) => (
                <TextField
                  disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Courses"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Autocomplete
              name="Status"
              fullWidth
              options={BatchStatuses}
              getOptionLabel={(option) => option.name || ""}
              onChange={handlestatus}
              value={
                BatchStatuses.find((statuses) => statuses.id === status) || ""
              }
              renderInput={(params) => (
                <TextField
                  disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Status"
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={smoSmeLeads.data}
          meta={smoSmeLeads?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="course_batch_id"
          rowClick={false}
          // actionComponent={
          //   <>
          //     <ActionDetails val={rowData?.batchName} />
          //     <GlobalAnchorList
          //       label=""
          //       component={<AssignTutor rowData={rowData} />}
          //     />
          //   </>
          // }
        />
        {subjectopen && selectedRow && (
          <SubjectAndTutors
            rowData={selectedRow}
            open={subjectopen}
            setOpen={setSubjectOpen}
            dispatchData={data}
          />
        )}
        {assignopen && selectedRow && (
          <AssignSme
            rowData={selectedRow}
            open={assignopen}
            setOpen={setAssignOpen}
            dispatchData={data}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default SMEbatchLeads;
